// extracted by mini-css-extract-plugin
export default {"baseTitle":"PageTitle_baseTitle__ht2Gt"};